import { StoryModel } from 'types/story';

const initialState: StoryModel | Partial<StoryModel> = {};

export default initialState;
